module.exports = __webpack_public_path__ + "img/logo5.42f889fe.png";